const avatarChangedEventName = "123zap:user-avatar-changed";

export const diceBearBlobsBaseUrl = "https://api.dicebear.com/10.x/blobs/svg";

export const defaultAvatarStyle = "blobs";

export const avatarBackgroundColors = ["8142fc", "6d28d9", "4338ca", "1d4ed8", "0369a1", "0f766e", "047857", "b45309", "be185d", "1e293b"];
export const avatarFaceColors = ["000000", "ffffff"];

const allowedBlobsOptionsByField = {
  backgroundColor: avatarBackgroundColors,
  blobColor: avatarFaceColors,
  blobVariant: ["drift", "dune", "pool", "melt", "drop", "pond"],
  bodyVariant: ["duo", "trio", "quartet"],
};

export function normalizeAvatarColor(value) {
  return String(value || "").trim().replace(/^#/, "").toLowerCase();
}

export function normalizeAvatarConfig(config) {
  if (!config || typeof config !== "object") return null;
  if (config.provider && config.provider !== "dicebear") return null;
  if (config.style !== defaultAvatarStyle) return null;

  const seed = String(config.seed || "").trim();
  if (!seed) return null;

  const rawOptions = config.options || {};
  const sanitizedOptions = Object.entries(rawOptions).reduce((options, [key, value]) => {
    const allowedOptions = allowedBlobsOptionsByField[key];
    const normalized = key.toLowerCase().includes("color") ? normalizeAvatarColor(value) : value;

    if (allowedOptions && allowedOptions.includes(normalized)) {
      options[key] = normalized;
    }

    return options;
  }, {});

  return {
    provider: config.provider || "dicebear",
    style: defaultAvatarStyle,
    seed,
    options: sanitizedOptions,
  };
}

export function buildDiceBearAvatarUrl(config) {
  const normalizedConfig = normalizeAvatarConfig(config);
  if (!normalizedConfig) return "";

  const params = new URLSearchParams({
    radius: "50",
    seed: normalizedConfig.seed,
  });

  Object.entries(normalizedConfig.options || {}).forEach(([key, value]) => {
    const normalized = String(value || "").trim();

    if (!normalized) return;
    params.set(key, normalized);
  });

  return `${diceBearBlobsBaseUrl}?${params.toString()}`;
}

export function getStoredAvatarConfig(user) {
  const backendConfig = user?.avatar_config || user?.avatarConfig;
  if (backendConfig && typeof backendConfig === "object") {
    return backendConfig;
  }

  return null;
}

export function subscribeToAvatarChanges(callback) {
  if (typeof window === "undefined") return () => {};

  window.addEventListener(avatarChangedEventName, callback);
  window.addEventListener("storage", callback);

  return () => {
    window.removeEventListener(avatarChangedEventName, callback);
    window.removeEventListener("storage", callback);
  };
}

export function buildUserAvatarUrl(user) {
  const directUrl = String(
    user?.user_avatar_url ||
      user?.userAvatarUrl ||
      user?.avatar_url ||
      user?.avatarUrl ||
      user?.picture_url ||
      user?.pictureUrl ||
      user?.photo_url ||
      user?.photoUrl ||
      ""
  ).trim();
  if (directUrl) return directUrl;

  return buildDiceBearAvatarUrl(getStoredAvatarConfig(user));
}
